import React from 'react';
import { PencilIcon, Trash2Icon } from 'lucide-react';
import type { CaseEntry } from '../../../types/caseEntry';
import { entrySubtotal, formatEntryDate } from '../../../utils/caseEntries';
import { formatQuantity } from '../../../utils/caseEstimate';
import { formatKr } from '../../../utils/quote';
interface EntryRowProps {
  entry: CaseEntry;
  active: boolean;
  onEdit: (entry: CaseEntry) => void;
  onDelete: (entry: CaseEntry) => void;
}

/** Én registreret linje med ret/slet. */
export function EntryRow({
  entry,
  active,
  onEdit,
  onDelete
}: EntryRowProps) {
  const detail = entry.unit === 'fast pris' && entry.quantity === 1 ? 'Fast beløb' : `${formatQuantity(entry.quantity)} ${entry.unit} × ${formatKr(entry.unitPrice)}`;
  return <li className={`flex items-center gap-3 py-3 ${active ? 'bg-accent/5' : ''}`} data-id="element-208" data-mp="23nief7bf8oxy">
      <div className="min-w-0 flex-1" data-id="element-209" data-mp="28mbvf9px2y2v">
        <p className="truncate text-[15px] font-medium text-ink" data-id="element-210" data-mp="2djc29mulc4v1">{entry.description}</p>
        <p className="text-sm text-ink-muted" data-id="element-211" data-mp="2uhxlf5jjblgx">
          {[entry.date ? formatEntryDate(entry.date) : '', detail, entry.purchasePrice !== undefined ? `indkøb ${formatKr(entry.purchasePrice)}` : ''].filter(Boolean).join(' · ')}
        </p>
      </div>
      <p className="shrink-0 whitespace-nowrap text-[15px] font-semibold text-ink" data-id="element-212" data-mp="2gipgrx4lrl5c">
        {formatKr(entrySubtotal(entry))}
      </p>
      <div className="flex shrink-0 gap-0.5" data-id="element-213" data-mp="3d7x6zig62ifl">
        <button type="button" onClick={() => onEdit(entry)} aria-label={`Ret ${entry.description}`} className="rounded-lg p-2 text-ink-faint transition-colors duration-150 hover:bg-canvas-deep hover:text-ink" data-id="element-214" data-mp="3973iamuwgzln">
          <PencilIcon className="h-4 w-4" aria-hidden="true" data-id="element-215" data-mp="2zgs1hzq4avxc" />
        </button>
        <button type="button" onClick={() => onDelete(entry)} aria-label={`Slet ${entry.description}`} className="rounded-lg p-2 text-ink-faint transition-colors duration-150 hover:bg-canvas-deep hover:text-danger" data-id="element-216" data-mp="rtkvs1ygik7">
          <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="jvdfxebhdux8" />
        </button>
      </div>
    </li>;
}